import { useCallback, useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking';
import { PlaylistCreatedAndAssignedByLabel } from '../../savedItems';
import { useCreatePlaylist } from '../../savedItems/savedItemsQueries';
import useNavigate from '../../../hooks/useNavigate';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import { useMyPlaylistsFilters, useMyPlaylistsParams } from '../myPlaylistsHooks';
import { useMyPlaylists } from '../myPlaylistsQueries';
import { MY_PLAYLISTS_SORT_MAP, MY_PLAYLISTS_TABS_MAP_TO_INTERACTION } from '../myPlaylistsTypes';
import { useDisplayedData } from '../../table/tableHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useHasScope } from '../../accounts';
import { RouterLink } from '../../../components/AcademyLinks';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { View } from 'foundations-components/transitional/components/View';
import { PageHeader } from '../../header/components/PageHeader';
import { FiltersCard } from '../../filters/components/FiltersCard';
import { PageResultsCount } from '../../header/components/PageResultsCount';
import { PAGE_SIZE } from '../../pagination/paginationConsts';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import ApiError from '../../../components/Errors/ApiError';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { NavMarker } from 'react-rhumb';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import NoResultsError from '../../../components/Errors/NoResultsError';
import { useLocation } from 'quartz-routing/react-router';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { SearchFilter } from '../../filters/components/SearchFilter';
import { H4 } from 'foundations-components/transitional/components/H4';
import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import { safeSmoothScrollTo } from '../../../utils/utils';
import { usePagination } from '../../pagination/paginationHooks';
import { MyPlaylistsButtonGroupFilter } from '../../filters/components/MyPlaylistsButtonGroupFilter';
import { SortByAccess } from '../../filters/components/SortByAccess';
import { SortByRelevance } from '../../filters/components/SortByRelevance';
import { MyPlaylistsDropdownFilter } from '../../filters/components/MyPlaylistsDropdownFilter';
//@ts-expect-error Could not find declaration file for module
import playlistTableUrl from 'bender-url!../../../../images/my-playlists-empty-state.svg';
import { usePageTitle } from '../../../hooks/usePageTitle';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MY_PLAYLISTS_TAB_TITLE_I18N_KEYS = {
  all: 'learningCenter.pageTitles.myPlaylistsAllPlaylists',
  'assigned-to-me': 'learningCenter.pageTitles.myPlaylistsAssignedToMe',
  'created-by-me': 'learningCenter.pageTitles.myPlaylistsCreatedByMe',
  saved: 'learningCenter.pageTitles.myPlaylistsSaved',
  archived: 'learningCenter.pageTitles.myPlaylistsArchived'
};
const useMyPlaylistsTab = () => {
  const {
    tab
  } = useMyPlaylistsParams();
  const {
    searchFilter,
    sortByAll: sortBy
  } = useMyPlaylistsFilters();
  const {
    currentPage: page
  } = usePagination();
  const hasFilters = searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.length;
  const {
    sortProperty,
    sortOrder
  } = MY_PLAYLISTS_SORT_MAP[sortBy || (searchFilter ? 'RELEVANCE_DESCENDING' : 'RECENTLY_ACCESSED_DESCENDING')];
  const {
    totalPlaylists,
    playlists,
    playlistsLoading,
    playlistsError
  } = useMyPlaylists({
    interactionTypes: MY_PLAYLISTS_TABS_MAP_TO_INTERACTION[tab || 'all'],
    limit: PAGE_SIZE,
    page,
    sortOrder,
    sortProperty,
    query: searchFilter
  });
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError,
    userProgressDataLoading
  } = useLearningContentCardModels({
    items: (playlists === null || playlists === void 0 ? void 0 : playlists.map(({
      id,
      type,
      hiddenForOwner
    }) => ({
      id,
      type: type === 'LEARNING_PATH' ? 'LEARNING_PATH' : 'PLAYLIST',
      hiddenForOwner
    }))) || [],
    skip: !playlists
  });
  return {
    totalPlaylists,
    page,
    playlists: cardModels,
    playlistsLoading: playlistsLoading || cardModelsLoading || userProgressDataLoading,
    playlistsError: playlistsError || cardModelsError,
    hasFilters,
    searchFilter,
    sortBy,
    tab
  };
};
const HubspotPlaylistsAdminLink = () => {
  return /*#__PURE__*/_jsxs(RouterLink, {
    to: '/hubspot-playlists-admin',
    children: [/*#__PURE__*/_jsx(HelpIcon, {
      marginInlineEnd: "100",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.admin.subtitle"
      }),
      tooltipPlacement: "left"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.hubspotPlaylists.admin.heading"
    })]
  });
};
const ItemRightComponent = props => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: playlistTableUrl
  }, props));
};
const MyPlaylistsNoResults = ({
  tab
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MY_PLAYLISTS_LISTING_API_404",
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "my-playlists-empty",
      marginBlockEnd: "400",
      marginBlockStart: isMobile ? '600' : undefined,
      children: /*#__PURE__*/_jsxs(BlankPageMediaWrapper, {
        itemRightComponent: ItemRightComponent,
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.myPlaylists.tab.${tab}.blankHeader`
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `learningCenter.myPlaylists.tab.${tab}.blankBody`
          })
        })]
      })
    })
  });
};
const MyPlaylistsNoResultsWithFilter = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MY_PLAYLISTS_LISTING_API_404",
    children: /*#__PURE__*/_jsx(NoResultsError, {
      resetLink: location.pathname
    })
  });
};
const MyPlaylistsContent = ({
  playlistsToDisplay,
  playlists,
  tab,
  totalCount
}) => {
  const {
    currentPage,
    setPage
  } = usePagination();
  const {
    isTablet
  } = useMediaQuery();
  const isGhost = useCallback(playlistId => playlists !== null && !playlists.some(p => p.id === playlistId), [playlists]);
  const isArchived = useCallback(playlistId => tab !== 'archived' && playlists !== null && playlists.some(p => p.id === playlistId && p.hiddenForOwner), [playlists, tab]);
  const handlePageChange = pageNumber => {
    setPage(pageNumber);
    safeSmoothScrollTo(window, 0, 0);
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MY_PLAYLISTS_LISTING_LOADED",
    children: /*#__PURE__*/_jsx(PaginatedUICardGrid, {
      isLoadingPageOnDemand: true,
      limit: PAGE_SIZE,
      onPageChange: handlePageChange,
      page: currentPage,
      shouldRenderOneColumn: isTablet,
      totalCount: totalCount,
      children: playlistsToDisplay === null || playlistsToDisplay === void 0 ? void 0 : playlistsToDisplay.map(playlist => {
        const {
          id
        } = playlist;
        return /*#__PURE__*/_jsx(LearningContentCard, {
          body: !isTablet && tab !== 'created-by-me' && tab !== 'archived' && /*#__PURE__*/_jsx(PlaylistCreatedAndAssignedByLabel, {
            marginBlockEnd: isTablet ? '0' : '200',
            playlistId: id
          }),
          isGhost: isGhost(id) || isArchived(id),
          item: playlist,
          overviewType: "my-playlists",
          ribbonText: !isTablet && isArchived(id) && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myPlaylists.archived"
          }),
          ribbonUse: "koala",
          size: isTablet ? 'small' : 'large'
        }, id);
      })
    })
  });
};
export const MyPlaylistsTabs = () => {
  const {
    hasFilters,
    playlists,
    page,
    totalPlaylists,
    playlistsLoading,
    playlistsError,
    searchFilter,
    sortBy,
    tab
  } = useMyPlaylistsTab();
  const navigate = useNavigate();
  const {
    createPlaylist,
    createPlaylistLoading
  } = useCreatePlaylist({
    onCompleted(playlist) {
      UsageTracker.trackStandalone('Playlist Interaction', {
        action: 'playlist-created',
        location: 'playlist-page-header'
      });
      navigate(`${MY_PLAYLISTS_URL_FRAGMENT}/${playlist.id}`);
    },
    onError() {
      FloatingAlertStore.addAlert({
        message: I18n.text('learningCenter.savedItems.playlistDetails.createPlaylistError'),
        type: 'danger'
      });
    }
  });
  const tabTitleI18nKey = MY_PLAYLISTS_TAB_TITLE_I18N_KEYS[tab || 'all'];
  usePageTitle({
    i18nKey: tabTitleI18nKey
  });
  const {
    isMobile,
    isTablet
  } = useMediaQuery();

  // displays only initial data dependent on tab, page and filters in order
  // to render ghosts
  const displayedData = useDisplayedData({
    playlists,
    totalPlaylists
  }, {
    loading: playlistsLoading,
    parameters: {
      tab,
      page,
      searchFilter,
      sortBy
    }
  });
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.MY_PLAYLISTS
    });
  }, []);
  const onCreatePlaylistClick = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'create-playlist',
      location: 'playlist-page-header'
    });
    createPlaylist({
      name: I18n.text('learningCenter.savedItems.newPlaylistTitle'),
      description: '',
      items: []
    }).catch(error => {
      Raven.captureException(error);
    });
  };
  const {
    hasScope: hasPublicPlaylistsAdminScope
  } = useHasScope('academy-public-playlists-admin');
  const {
    playlists: playlistsToDisplay,
    totalPlaylists: displayedTotalPlaylists
  } = displayedData || {};
  const showFiltersCard = (playlistsToDisplay === null || playlistsToDisplay === void 0 ? void 0 : playlistsToDisplay.length) !== 0 || hasFilters;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_PLAYLISTS"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_PLAYLISTS"
      }),
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "create-playlist-button",
        loading: createPlaylistLoading,
        onClick: onCreatePlaylistClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.savedItems.createPlaylist"
        })
      })
    }), !isMobile && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!playlistsLoading && /*#__PURE__*/_jsx(PageResultsCount, {
        page: page - 1,
        pageSize: PAGE_SIZE,
        total: displayedTotalPlaylists || 0
      }), /*#__PURE__*/_jsx(FiltersCard, {
        rightSlot: hasPublicPlaylistsAdminScope ? /*#__PURE__*/_jsx(HubspotPlaylistsAdminLink, {}) : null,
        shouldRenderClearFilters: false,
        children: isTablet ? /*#__PURE__*/_jsx(MyPlaylistsDropdownFilter, {
          appearsIn: "my-playlists"
        }) : /*#__PURE__*/_jsx(MyPlaylistsButtonGroupFilter, {
          appearsIn: "my-playlists"
        })
      }), showFiltersCard && /*#__PURE__*/_jsxs(FiltersCard, {
        "data-test-id": "my-playlists-filters",
        children: [/*#__PURE__*/_jsx(SearchFilter, {
          appearsIn: "my-playlists",
          marginInlineEnd: "600",
          maxInlineSize: "300px",
          placeholder: I18n.text('learningCenter.myPlaylists.searchPlaceholder')
        }), /*#__PURE__*/_jsx(SortByAccess, {
          appearsIn: "my-playlists"
        }), (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.length) && /*#__PURE__*/_jsx(SortByRelevance, {
          appearsIn: "my-playlists"
        })]
      })]
    }), isMobile && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(TFlex, {
        alignItems: "center",
        gap: 16,
        marginBlockEnd: "600",
        children: [/*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(MyPlaylistsDropdownFilter, {
            appearsIn: "my-playlists"
          })
        }), showFiltersCard && /*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          children: /*#__PURE__*/_jsx(SearchFilter, {
            appearsIn: "my-playlists",
            placeholder: I18n.text('learningCenter.myPlaylists.searchPlaceholder')
          })
        })]
      }), !playlistsLoading && /*#__PURE__*/_jsx(PageResultsCount, {
        page: page - 1,
        pageSize: PAGE_SIZE,
        total: displayedTotalPlaylists || 0
      })]
    }), /*#__PURE__*/_jsx(View, {
      children: playlistsError ? /*#__PURE__*/_jsx(ApiError, {
        error: playlistsError,
        marker404: "MY_PLAYLISTS_LISTING_API_404",
        markerDefault: "MY_PLAYLISTS_LISTING_API_ERROR"
      }) : playlistsLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 100
      }) : playlistsToDisplay !== null && playlistsToDisplay !== void 0 && playlistsToDisplay.length ? /*#__PURE__*/_jsx(MyPlaylistsContent, {
        playlists: playlists || [],
        playlistsToDisplay: playlistsToDisplay,
        tab: tab,
        totalCount: displayedTotalPlaylists || 0
      }) : hasFilters ? /*#__PURE__*/_jsx(MyPlaylistsNoResultsWithFilter, {}) : /*#__PURE__*/_jsx(MyPlaylistsNoResults, {
        tab: tab
      })
    })]
  });
};